enum TaxiOfficerEditViewMode {
  TAXI = "TAXI",
  RAILY = "RAILY",
}

export default TaxiOfficerEditViewMode;
